module.exports = __webpack_public_path__ + "img/open-bg-4.810aa84d.png";